import { Component, type ErrorInfo, type ReactNode } from 'react';
import { useI18n } from '@nx/i18n';
import './AppErrorBoundary.css';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

function AppErrorFallback() {
  const { t } = useI18n();

  return (
    <div className="app-error-boundary" role="alert">
      <div className="app-error-boundary__card">
        <h1 className="app-error-boundary__title">{t('common.errorBoundary.title')}</h1>
        <p className="app-error-boundary__message">{t('common.errorBoundary.message')}</p>
        <div className="app-error-boundary__actions">
          <button
            type="button"
            className="tp-btn tp-btn-primary"
            onClick={() => window.location.reload()}
          >
            {t('common.errorBoundary.reload')}
          </button>
        </div>
      </div>
    </div>
  );
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('AppErrorBoundary caught an error:', error, errorInfo);
  }

  override render() {
    if (this.state.error) {
      return <AppErrorFallback />;
    }
    return this.props.children;
  }
}
